import React, { FC } from "react";

import { Select } from "~/ui-kit/components/Select/Select";
import { LocaleCodes } from "~/common/types/common";
import { MerchantLanguage } from "~/common/types/merchant";

import flagEN from "~/assets/images/flag_en.png";
import flagDE from "~/assets/images/flag_de.png";
import flagFR from "~/assets/images/flag_fr.png";
import flagES from "~/assets/images/flag_es_spanish.svg";
import flagPT from "~/assets/images/flag_pt_portuguese.svg";
import flagIT from "~/assets/images/flag_it_italian.svg";
import flagPL from "~/assets/images/flag_pl_polish.svg";
import flagNL from "~/assets/images/flag_nl_dutch.svg";
import flagDA from "~/assets/images/flag_da_danish.svg";
import flagFI from "~/assets/images/flag_fi_finnish.svg";
import flagEL from "~/assets/images/flag_el_greek.svg";
import flagCA from "~/assets/images/flag_ca_catalan.svg";
import flagSV from "~/assets/images/flag_sv_swedish.svg";
import flagCS from "~/assets/images/flag_cs_czech.svg";
import flagET from "~/assets/images/flag_et_estonian.svg";
import flagHU from "~/assets/images/flag_hu_hungarian.svg";
import flagLT from "~/assets/images/flag_lt_lithuanian.svg";
import flagLV from "~/assets/images/flag_lv_latvian.svg";
import flagSK from "~/assets/images/flag_sk_slovak.svg";
import flagSL from "~/assets/images/flag_sl_slovenian.svg";
import flagBG from "~/assets/images/flag_bg_bulgarian.svg";
import flagGA from "~/assets/images/flag_ga_irish.svg";
import flagHR from "~/assets/images/flag_hr_croatian.svg";
import flagUK from "~/assets/images/flag_uk_ukrainian.svg";
import flagMT from "~/assets/images/flag_mt_maltese.svg";
import flagRO from "~/assets/images/flag_ro_romanian.svg";
import flagRU from "~/assets/images/flag_ru_russian.svg";

import "./SelectLanguage.css";

const languageMap = {
  en: {
    flag: flagEN,
    text: "English",
  },
  de: {
    flag: flagDE,
    text: "Deutsch",
  },
  fr: {
    flag: flagFR,
    text: "Français",
  },
  es: {
    flag: flagES,
    text: "Spanish",
  },
  pt: {
    flag: flagPT,
    text: "Portuguese",
  },
  it: {
    flag: flagIT,
    text: "Italian",
  },
  pl: {
    flag: flagPL,
    text: "Polish",
  },
  nl: {
    flag: flagNL,
    text: "Dutch",
  },
  da: {
    flag: flagDA,
    text: "Danish",
  },
  fi: {
    flag: flagFI,
    text: "Finnish",
  },
  el: {
    flag: flagEL,
    text: "Greek",
  },
  ca: {
    flag: flagCA,
    text: "Catalan",
  },
  sv: {
    flag: flagSV,
    text: "Swedish",
  },
  cs: {
    flag: flagCS,
    text: "Czech",
  },
  et: {
    flag: flagET,
    text: "Estonian",
  },
  hu: {
    flag: flagHU,
    text: "Hungarian",
  },
  lt: {
    flag: flagLT,
    text: "Lithuanian",
  },
  lv: {
    flag: flagLV,
    text: "Latvian",
  },
  sk: {
    flag: flagSK,
    text: "Slovak",
  },
  sl: {
    flag: flagSL,
    text: "Slovenian",
  },
  bg: {
    flag: flagBG,
    text: "Bulgarian",
  },
  ga: {
    flag: flagGA,
    text: "Irish",
  },
  hr: {
    flag: flagHR,
    text: "Croatian",
  },
  uk: {
    flag: flagUK,
    text: "Ukrainian",
  },
  mt: {
    flag: flagMT,
    text: "Maltese",
  },
  ro: {
    flag: flagRO,
    text: "Romanian",
  },
  ru: {
    flag: flagRU,
    text: "Russian",
  },
};

const LanguageLabel = ({ languageName, languageCode }) => {
  const { flag, text } = languageMap[languageCode] || {};
  return (
    <div className="d-flex align-items-center">
      {flag ? (
        <img
          className="rounded-circle select-language-flag me-2"
          src={flag}
          alt={text}
        />
      ) : (
        <div className="select-language-flag me-2"></div>
      )}
      {languageName}
    </div>
  );
};

export type SelectLanguageProps = {
  selected: LocaleCodes;
  merchantLanguages: MerchantLanguage[];
  onChange: (language: LocaleCodes) => void;
};

export const SelectLanguage: FC<SelectLanguageProps> = ({
  selected,
  merchantLanguages = [],
  onChange,
}) => {
  const languagesOptions = merchantLanguages.map((merchantLanguage) => ({
    value: merchantLanguage.langCode,
    label: (
      <LanguageLabel
        languageName={merchantLanguage.langName}
        languageCode={merchantLanguage.langCode}
      />
    ),
  }));
  return (
    <Select options={languagesOptions} value={selected} onChange={onChange} />
  );
};
